import { type LinkSearchListItemData } from '@atlaskit/link-picker';

export const filterItems = (
	items: Array<LinkSearchListItemData> | undefined,
	searchTerm: string,
): Array<LinkSearchListItemData> => {
	if (!searchTerm || !items) {
		return [];
	}

	return items.filter((item) => {
		return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
	});
};
